module.exports = __webpack_public_path__ + "img/dangyuanrenshu_icon.bfb53ae8.png";